import { Link } from "@tanstack/react-router";
import { Logo } from "./logo";

export function SiteFooter() {
  return (
    <footer className="border-t border-brand-deep/5 bg-white py-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="space-y-4 md:col-span-1">
            <Logo />
            <p className="max-w-[28ch] text-sm leading-relaxed text-brand-deep/60">
              Precision content. Scientific growth. A digital marketing agency built for the AI era.
            </p>
            <address className="not-italic text-sm leading-relaxed text-brand-deep/70">
              <a href="mailto:mgcontentservices@gmail.com" className="hover:text-brand-accent">
                mgcontentservices@gmail.com
              </a>
              <br />
              New Delhi, India · Working worldwide
            </address>
          </div>
          <div>
            <p className="mb-4 text-[10px] font-bold uppercase tracking-widest text-brand-deep">Services</p>
            <ul className="space-y-3 text-sm text-brand-deep/70">
              <li><Link to="/services/$slug" params={{ slug: "seo" }} className="hover:text-brand-accent">SEO Content Strategy</Link></li>
              <li><Link to="/services/$slug" params={{ slug: "content" }} className="hover:text-brand-accent">Content Writing</Link></li>
              <li><Link to="/services/$slug" params={{ slug: "smo" }} className="hover:text-brand-accent">Social Media Optimization</Link></li>
              <li><Link to="/services/$slug" params={{ slug: "optimization" }} className="hover:text-brand-accent">Content Optimization</Link></li>
              <li><Link to="/services/$slug" params={{ slug: "linkbuilding" }} className="hover:text-brand-accent">Link Building</Link></li>
              <li><Link to="/services/$slug" params={{ slug: "aeo" }} className="hover:text-brand-accent">Answer Engine Optimization</Link></li>
            </ul>
          </div>

          <div>
            <p className="mb-4 text-[10px] font-bold uppercase tracking-widest text-brand-deep">Company</p>
            <ul className="space-y-3 text-sm text-brand-deep/70">
              <li><Link to="/about" className="hover:text-brand-accent">About</Link></li>
              <li><Link to="/careers" className="hover:text-brand-accent">Careers</Link></li>
              <li><Link to="/pricing" className="hover:text-brand-accent">Pricing</Link></li>
              <li><Link to="/blog" className="hover:text-brand-accent">Blog</Link></li>
              <li><Link to="/tools/headline-analyzer" className="hover:text-brand-accent">Free Headline Analyzer</Link></li>
              <li><Link to="/tools/keyword-explorer" className="hover:text-brand-accent">Free Keyword Explorer</Link></li>
              <li><Link to="/tools/website-audit" className="hover:text-brand-accent">Free Website Audit</Link></li>
              <li><Link to="/contact" className="hover:text-brand-accent">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="mb-4 text-[10px] font-bold uppercase tracking-widest text-brand-deep">Legal</p>
            <ul className="space-y-3 text-sm text-brand-deep/70">
              <li><Link to="/privacy" className="hover:text-brand-accent">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-brand-accent">Terms of Service</Link></li>
              <li><a href="/sitemap.xml" className="hover:text-brand-accent">Sitemap</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-brand-deep/5 pt-6 text-xs text-brand-deep/80 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} MG Content Labs. Precision Content. Scientific Growth.</span>
        </div>
      </div>
    </footer>
  );
}
